"use client";

import { VideoPlayer } from "@/component/VideoPlayer";
import { convertFilePathToUrl } from "@/util/convertFilePathToUrl";
import { useEffect, useRef } from "react";

interface ThreadMediaProps {
  src?: string | null;
  onVideoPlayerHeightChange?: (height: number) => void;
}

export function ThreadMedia({
  src,
  onVideoPlayerHeightChange,
}: ThreadMediaProps) {
  const videoSrc = convertFilePathToUrl(src || undefined);
  const videoPlayerRef = useRef<HTMLDivElement>(null);

  // 监听 VideoPlayer 的高度变化
  useEffect(() => {
    if (!videoSrc || !videoPlayerRef.current || !onVideoPlayerHeightChange) {
      return;
    }

    const resizeObserver = new ResizeObserver((entries) => {
      const height = entries[0]?.target.getBoundingClientRect().height;
      if (height) {
        onVideoPlayerHeightChange(height);
      }
    });

    resizeObserver.observe(videoPlayerRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [videoSrc, onVideoPlayerHeightChange]);

  return (
    <div className="flex-1 h-full flex items-center">
      {videoSrc ? (
        <div ref={videoPlayerRef} className="w-full">
          <VideoPlayer
            src={videoSrc}
            className="w-full items-start"
            style={{ borderRadius: "16px", overflow: "hidden" }}
          />
        </div>
      ) : (
        <div
          className="flex w-full aspect-video items-center justify-center text-gray-500"
          role="status"
          aria-label="Video unavailable"
        >
          Video not found
        </div>
      )}
    </div>
  );
}
